/**
 * «Subiendo la base de HATSU»: la marca sobre la que se está trabajando, a la vista en las pantallas que cargan o usan
 * datos de un cliente (Subir base, Segmentar), para no cargarle la base a otro. El nombre es el de `nombreActual`, el
 * mismo del selector de marca; si no se guardó, cae al id de la marca, y así se dice.
 */
import { Store } from "lucide-react";
import { activaApi } from "../api";

const ES_ID = /^[0-9a-f]{24}$/i;

/** Cómo se nombra la marca: su nombre, o «la marca <id>» si sólo se conoce el id. */
export function nombreDeTrabajo(nombre: string | null | undefined): string {
  const n = String(nombre ?? "").trim();
  return ES_ID.test(n) ? `la marca ${n}` : n;
}

export function MarcaDeTrabajo({ accion }: { /** «Subiendo la base de», «Segmentando la base de» */ accion: string }) {
  const nombre = nombreDeTrabajo(activaApi.nombreActual());
  if (!nombre) return null;
  return (
    <p data-testid="marca-de-trabajo" className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-violet-50 px-3 py-1 text-sm text-violet-900">
      <Store size={14} className="shrink-0" aria-hidden="true" />
      <span className="truncate">
        {accion} <strong className="font-semibold">{nombre}</strong>
      </span>
    </p>
  );
}
